const GroupList = () => import('Views/group/group-list');
const GroupAddEdit = () => import('Views/group/group-addEdit');
const GroupDevice = () => import('Views/group/group-device');

export default [
  { path: '/group-list', component: GroupList },
  { path: '/group-add', component: GroupAddEdit },
  { path: '/group-edit/:id', component: GroupAddEdit },
  { path: '/group-device', component: GroupDevice },
];



// WEBPACK FOOTER //
// ./src/router/group.js